import type { ReactNode } from "react";
import { Tooltip, TooltipContent } from "@/components/ui/tooltip.tsx";

export interface CapTooltipProps {
    isShown: boolean;
    label: string;
    children: ReactNode;
}

export function CapTooltip({ isShown, label, children }: CapTooltipProps) {
    if (!isShown) {
        return <>{children}</>;
    }

    return (
        <Tooltip delay={0} closeDelay={0}>
            {children}
            <TooltipContent>{label}</TooltipContent>
        </Tooltip>
    );
}
